import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // envoie le cookie HttpOnly automatiquement
  headers: {
    "Content-Type": "application/json",
  },
});

// --- CSRF Protection ---
let csrfToken = null;

function fetchCsrfToken() {
  return axios
    .get(`${API_BASE_URL}/api/auth/csrf-token`, { withCredentials: true })
    .then((res) => {
      csrfToken = res.data.csrf_token;
    })
    .catch(() => {});
}

fetchCsrfToken();

const MUTATING_METHODS = ["post", "put", "patch", "delete"];

api.interceptors.request.use(
  (config) => {
    if (csrfToken && MUTATING_METHODS.includes(config.method)) {
      config.headers["X-CSRF-Token"] = csrfToken;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 403 &&
      error.response?.data?.detail?.includes("CSRF") &&
      !originalRequest._csrfRetry
    ) {
      originalRequest._csrfRetry = true;
      await fetchCsrfToken();
      if (csrfToken) {
        originalRequest.headers["X-CSRF-Token"] = csrfToken;
        return api.request(originalRequest);
      }
    }

    if (error.response?.status === 401 && !originalRequest.url?.includes("/api/auth/")) {
      window.location.href = "/authentication/sign-in";
    }
    return Promise.reject(error);
  }
);

export default api;
